import Layout from 'layout/index';
import * as React from 'react';
import { ApartmentDetails } from 'sections/ApartmentDetails/ApartmentDetails';
import { getDisabledPages, getDynamicPages } from 'utils/utils';

interface MieszkaniaPageProps {
    location: {
        pathname: string;
    };
    pageContext: any;
}

export default ({ location, pageContext }: MieszkaniaPageProps) => {
    const pageTitle = `${pageContext?.title} - Mieszaknia - Mieszkanie ${pageContext?.flat?.investmentFlat?.flatNumber}`;

    return (
        <Layout
            headerData={pageContext?.headerData}
            investmentSlug={pageContext?.slug}
            pageTitle={pageTitle}
            location={location}
            investmentDisabledPages={getDisabledPages(pageContext?.headerData)}
            investmentDynamicPages={getDynamicPages(pageContext?.headerData)}
        >
            <ApartmentDetails data={pageContext} />
        </Layout>
    );
};
